import { Box, BoxProps } from "@mui/material";
import * as React from "react";

export default function AsideContainer(props: BoxProps) {
  return <Box sx={{ width: 1 / 3 }} marginLeft={1} {...props} />;
}
